const acceptCookies = (version, privacySettings, isLoggedIn) => ({
  type: 'ACCEPT_COOKIES',
  version,
  privacySettings,
  isLoggedIn,
});

export default acceptCookies;
